import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/static/icons/chevron-right.svg'


const _hoisted_1 = {
  key: 0,
  class: "facet-list-item-checkbox__values"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "facet-list-item-checkbox__arrow",
  src: _imports_0
}, null, -1)

import { computed } from 'vue';
import { FacetHit, getContext } from '@/composables/useDynamicProductListing';


export default /*#__PURE__*/_defineComponent({
  __name: 'FacetListItemCheckbox',
  props: {
    facet: null
  },
  setup(__props: any) {

const props = __props as {
  facet: FacetHit;
}



const { activeFacets, openFacetDrawer } = getContext();

const activeValues = computed(() => {
  const activeFacet = activeFacets.find((r) => r.id === props.facet.id);

  if (activeFacet) {
    return activeFacet.values.map((r) => r.label).join(', ');
  }
});

function open() {
  openFacetDrawer(props.facet);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "facet-list-item-checkbox clean-button",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (open()))
  }, [
    _createElementVNode("span", {
      class: _normalizeClass([
        'facet-list-item-checkbox__name',
        {
          'facet-list-item-checkbox__name--active': _unref(activeValues),
        },
      ])
    }, _toDisplayString(__props.facet.name), 3),
    (_unref(activeValues))
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(activeValues)), 1))
      : _createCommentVNode("", true),
    _hoisted_2
  ]))
}
}

})